if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // 2025.02.09 Add
      const checkItemQuantity = async (variantId) => {
        console.log("variantId",variantId);
        const cartContent = await (await fetch(`${routes.cart_url}.js`, {cache: 'reload'})).json();
        const cartItems = cartContent.items || [];
        const currentValItemQty = cartItems
          .filter((item) => item.id === parseInt(variantId))
          .reduce((acc, item) => acc + item.quantity, 0);
      
        return {
          currentValItemQty: currentValItemQty || 0,
          currentCartTotalPrice: cartContent.total_price
        }
      }

      (async () => {
        try {
          const currentVal = await checkItemQuantity(formData.get('id'));

          //2025.03.01 Add
          const addedItemPrice = this.form.querySelector('input[name="id"]').dataset.price ?
            1 * parseInt(this.form.querySelector('input[name="id"]').dataset.price)
            : 0;
          const addedCartTotalPrice = (currentVal.currentCartTotalPrice + addedItemPrice) / 100;

          let errorMessage = "";
          if(addedCartTotalPrice > 300000){
            errorMessage = "一度にご注文いただけるのは300,000円までとなります。";
          }

          const addedItemQty = currentVal.currentValItemQty + formData.get('quantity');
          if(addedItemQty >= 3){
            errorMessage = "この商品をカートに追加できるのは３点までとなります。なお、３点以下の場合も買占めが疑われる場合や数量制限をさせていただいている商品の場合は、ご注文自動キャンセルの対象となりますのでご留意ください。";
          }

          if(errorMessage !== ""){
            this.handleErrorMessage(errorMessage);
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;

            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            return;
          }
          
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
    
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
    
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        } catch (error) {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      })();
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
